import script from "./SharedBetslipError.vue?vue&type=script&setup=true&lang=js"
export * from "./SharedBetslipError.vue?vue&type=script&setup=true&lang=js"

import "./SharedBetslipError.vue?vue&type=style&index=0&id=567b324c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-567b324c"]])

export default __exports__